module.exports = __webpack_public_path__ + "img/costEffective.e6c5c49f.jpg";